import loadable from "@loadable/component";
import CreateIcon from "../../Icons/Create";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";

const CreateDeliveryChargeTemplateComponent = loadable(
  () => import("../../components/DeliveryChargeTemplate/CreateDeliveryChargeTemplate")
);
const CreateDeliveryChargeTemplate = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["delivery-charge-template"],
    navigateURL: "/delivery-charge-template",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.DELIVERY_CHARGE_TEMPLATE}`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Create Rate Template</span>
      </div>
      <CreateDeliveryChargeTemplateComponent
        isLoading={isPostLoading}
        handleCreate={handleCreate}
      />
    </>
  );
};

export default CreateDeliveryChargeTemplate
